export const START_DATE = 'startDate';
export const END_DATE = 'endDate';



// WEBPACK FOOTER //
// ./components/date-picker/components/calendar/calendar-constants.js